import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
const Banner = ({ message, submessage, ...rest }) => {
    if (!message && !submessage) {
        return null;
    }
    return (React.createElement(VStack, { background: "$surface.container", display: "flex", flexDirection: "row", borderStyle: "solid", borderWidth: 1, borderColor: "$neutral.20", borderLeftWidth: 0, borderRightWidth: 0, padding: "$4", marginBottom: "$2", marginTop: "$3", testID: "Banner.wrapper", ...rest },
        React.createElement(VStack, null,
            React.createElement(IconValidationInvalid, { color: "$support.danger.surfaceOnColorAlt", testID: "Banner.iconError" })),
        React.createElement(VStack, { marginLeft: "$2", display: "flex", flex: 1 },
            React.createElement(Text, { testID: "Banner.message", color: "$text.100", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default" }, message),
            React.createElement(Text, { testID: "Banner.message2", color: "$text.100", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.strong" }, submessage))));
};
export { Banner };
